import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { OutreachArea } from "../../../models/roles";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends OutreachArea>(name: Extract<keyof T, string>): string { return name; };

export const outreachMenu: MenuMainNode = {
    icon: 'outreachIconTemplate',
    title: 'Menu.Outreach.Name',  
    rootPath: '/outreach',  
    areaPermissionKey: permissionAreaKeyNameOf('outreach'),
    children: [       
        {
            title: 'Menu.Outreach.OutreachLists.Name',
            abbreviation: 'Menu.Outreach.OutreachLists.Abbreviation',
            link: '/outreach/lists',
            entityPermissionKey: entityKeyResolver("outreachLists")
        },
        {
            title: 'Menu.Outreach.OutreachCampaigns.Name',
            abbreviation: 'Menu.Outreach.OutreachCampaigns.Abbreviation',
            link: '/outreach/campaigns',
            entityPermissionKey: entityKeyResolver("outreachCampaigns")
        },
        {
            title: 'Menu.Outreach.OutreachTemplates.Name',
            abbreviation: 'Menu.Outreach.OutreachTemplates.Abbreviation',
            link: '/outreach/marketing-letter-templates',
            entityPermissionKey: entityKeyResolver("outreachTemplates")
        }
    ]
};
